interface FileDownloadArgs {
  blob: Blob;
  fileName: string;
}

export const useFileDownload = () => {
  const downloadFile = ({ blob, fileName }: FileDownloadArgs) => {
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return { downloadFile };
};
